import { loadPages } from '@common/redux/slice/page';
import { fetchPages } from '@common/services';
import { IAppInfo } from '@common/types';
import { appUseMap } from '@common/utils/component';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { TOKEN_KEY } from '@common/constants';
import { chunk } from 'lodash';

type APIResponse = {
  data: any;
  error: string | null;
  isLoading: boolean;
  isUseMap: boolean;
};

const EXPIRIES = 'cacheExpiresOn';
const SCREEN_LOCAL = 'screenLocal';

export const getAllPages = (appId: string, appInfo: IAppInfo | undefined) => {
  const dispatch = useDispatch();
  const [response, setResponse] = useState<APIResponse>({
    data: [],
    error: null,
    isLoading: true,
    isUseMap: false,
  });

  const _fetchPages = useCallback(async () => {
    setResponse((prev) => ({ ...prev, isLoading: true }));
    try {
      const params = {};

      let pages: any[] = [];
      if (appInfo) {
        const expiresOnLocal = await AsyncStorage.getItem(EXPIRIES);
        const expiresOn = appInfo?.cacheExpiresOn;
        const keys = await AsyncStorage.getAllKeys();

        if (expiresOnLocal !== expiresOn) {
          console.log('fetch api ---- ');
          const pageData = await fetchPages(appId, params);
          pages = pageData.data;

          // remove all token before saving
          const keyNoToken = keys.filter((i) => i != TOKEN_KEY);
          AsyncStorage.multiRemove(keyNoToken);
          // save pages to localstorage
          const chunkPages = chunk(pages, 20);
          const saveData = chunkPages.map((data, index) => [
            SCREEN_LOCAL + index,
            JSON.stringify(data),
          ]);

          try {
            await AsyncStorage.multiSet(saveData);
            await AsyncStorage.setItem(EXPIRIES, pageData.expiresOn);
          } catch (error) {
            await AsyncStorage.multiRemove(
              saveData.map((data) => data[0]).concat(EXPIRIES)
            );
          }
        } else {
          console.log('get local ---- ');
          const listKeys = keys.filter((key) => key.startsWith(SCREEN_LOCAL));
          pages = (await AsyncStorage.multiGet(listKeys))
            .map(([_key, page]) => JSON.parse(page ?? '[]'))
            .flat();
        }
      }
      const isUseMap = appUseMap(pages);

      dispatch(loadPages(pages));

      setResponse((prev) => ({
        ...prev,
        isUseMap,
        isLoading: false,
        data: pages,
      }));
    } catch (error: any) {
      setResponse((prev) => ({
        ...prev,
        isLoading: false,
        error: error.message || 'get data error',
      }));
    }
  }, [appId, appInfo]);

  useEffect(() => {
    _fetchPages();
  }, [_fetchPages]);

  return response;
};
